export default "__VITE_ASSET__O_tdf$QPvJNjf2YYamgnkg__"